<div class="mt-5 sm:mt-6" data-cy="order-wizard-footer">
  <div class="mt-5 sm:mt-6 flex w-full align-items-center justify-content-between">
    <button
      *ngIf="(previousStep$ | async) && !isMakePaymentPage"
      pButton
      type="button"
      [label]="(activeStep$ | async)?.previousStep || defaultPreviousStep"
      icon="mi-round mi-arrow-back"
      iconPos="left"
      class="p-button-outlined"
      (click)="onPrevious()"
      [disabled]="disableNav || (exitOrderWizard$ | async)?.isUpdating"
      data-cy="order-wizard-previous-button"
    ></button>
    <button
      pButton
      type="button"
      [label]="nextLabel || (isMakePaymentPage ? 'Submit' : ((exitOrderWizard$ | async)?.isUpdating ? 'Updating Order...' : (activeStep$ | async)?.nextStep || defaultNextStep))"
      class="p-button-rounded ml-auto"
      (click)="onNext()"
      [disabled]="disableNav || (exitOrderWizard$ | async)?.isUpdating"
      data-cy="order-wizard-next-button"
    ></button>
  </div>
</div>
<app-confirmation-modal
  [(visible)]="displayExitModal"
  title="Are You Sure?"
  [message]="exitMessage$ | async"
  submitLabel="Confirm"
  cancelLabel="Cancel"
  (confirmAction)="onConfirmExit()"
  (cancelAction)="onCancelExit()"
  data-cy="exit-confirmation-modal"
>
</app-confirmation-modal>
